import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BaseStepViewComponent } from './../base-step-view.class';
import { DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { DatasetService } from 'app/main/components/dataset/services/dataset.service';
import { AppService } from 'app/services/app.service';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'app/services/auth.service';
var DomainUserRolePermissionStepComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DomainUserRolePermissionStepComponent, _super);
    function DomainUserRolePermissionStepComponent(appService, datasetRS, datasetACS, datasetNavigatorService, datasetService, dialog, authService) {
        var _this = _super.call(this, datasetACS, datasetNavigatorService) || this;
        _this.appService = appService;
        _this.datasetRS = datasetRS;
        _this.datasetACS = datasetACS;
        _this.datasetNavigatorService = datasetNavigatorService;
        _this.datasetService = datasetService;
        _this.dialog = dialog;
        _this.authService = authService;
        _this.checked = false;
        _this.loading = false;
        _this.changingGroupAccess = {};
        _this.isAdmin = false;
        return _this;
    }
    DomainUserRolePermissionStepComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getPermissions();
        this.datasetRS.record
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (record) {
            if (!record)
                return;
            _this.isAdmin = record.level < 10;
        });
        /*this.authService.userDataObserver
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(userData => {
            this.isAdmin = this.authService.isAdministrator();
        });*/
    };
    DomainUserRolePermissionStepComponent.prototype.getPermissions = function () {
        var _this = this;
        this.loading = true;
        this.datasetService.post('/dataset/domain_user_roles/command/get_permissions', {
            domain_user_role_id: this.datasetRS.record.value.id
        })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
            next: function (response) {
                _this.rolePermissions = response;
                _this.loading = false;
                /*if (!this.loading) {
                    this.isCheckboxChecked();
                }*/
            },
            error: function (response) {
                _this.loading = false;
            }
        });
    };
    DomainUserRolePermissionStepComponent.prototype.isCheckboxChecked = function () {
        var permission = this.findPermissionByCode('booking_group');
        if (!permission)
            return;
        var action = this.getAction(permission, 'edit_booking_date');
        if (action && action.id)
            this.checked = true;
    };
    DomainUserRolePermissionStepComponent.prototype.findPermissionByCode = function (code) {
        return this.rolePermissions.find(function (permission) { return permission.code === code; });
    };
    DomainUserRolePermissionStepComponent.prototype.getAction = function (permission, actionCode) {
        return permission.actions.find(function (action) { return action.code === actionCode; });
    };
    DomainUserRolePermissionStepComponent.prototype.changeAccessType = function (group, level) {
        var _this = this;
        this.changingGroupAccess[group.id] = true;
        this.datasetService.post('/dataset/domain_user_roles/command/set_access_level', {
            domain_user_role_id: this.datasetRS.record.value.id,
            dataset_group_definition_id: group.id,
            access_level: level
        })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
            next: function (response) {
                delete _this.changingGroupAccess[group.id];
            },
            error: function (response) {
                delete _this.changingGroupAccess[group.id];
            }
        });
    };
    DomainUserRolePermissionStepComponent.prototype.commandPermission = function (userAction, group, action) {
        var _this = this;
        this.datasetService.post('/dataset/domain_user_roles/command/' + userAction, {
            dataset_action_definition_id: action.id,
            domain_user_role_id: this.datasetRS.record.value.id,
            dataset_group_definition_id: group.id
        })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
            next: function (response) {
                _this.getPermissions();
            },
            error: function (response) { }
        });
    };
    DomainUserRolePermissionStepComponent.prototype.changeState = function (group, action, active) {
        if (active) {
            this.commandPermission('set_permissions', group, action);
        }
        else {
            this.commandPermission('unset_permissions', group, action);
        }
    };
    return DomainUserRolePermissionStepComponent;
}(BaseStepViewComponent));
export { DomainUserRolePermissionStepComponent };
